export default {
  General: {
    Home: '主页',
    Alpacas: '羊驼',
    Adopt: '领养',
    Stake: '质押',
    Breeding: '繁育',
    Farm: '挖矿',
    Guide: '指南',
    AlpacaCity: '羊驼之城',
    Breed: '繁育',
    Alpapa: 'Alpapa',
    Almama: 'Almama',
    APY: 'APY',
    Confirm: '确认',
    Energy: '能量值',
    Claim: '收取',
    Deposit: '存入',
    Withdraw: '提取',
    GN: '代数',
    Birthday: '生日',
    Owner: '牧羊人',
    Traits: '性状',
    ConnectWalletFirst: '请连接钱包',
    Gen: '代数',
    Parents: '父母',
    Hatch: '孵化',
    Transfer: '转赠',
    Children: '孩子',
    MyAlpacas: '我的羊驼',
    OtherAlpacas: '其它羊驼',
    Approve: '授权',
    Approving: '授权中...',
    Cancel: '取消',
    Farms: '矿池',
    Substitute: '更换',
    Recall: '召回',
    Max: 'Max',
    Participate: '参与',
    Farming: 'Farming...',
    Squad: 'Squad',
    Available: '可用',
    ID: 'ID',
    Close: '关闭',
    Dismiss: '好的',
    ConnectWallet: '连接钱包',
    Choose: '选择',
    Assign: '集结',
    Players: '玩家数',
    Wool: 'Wool',
    WOOL: '羊毛',
    Recycle: '回收',
    Exchange: '置换',
    Save: '保存',
    Referral: '邀请好友',
    StakeIn: '质押',
    StakeOut: '解锁',
    Staked: '已质押',
    Earned: '已赚取',
    Boost: '能量增长',
    Feed: '喂食',
    Price: '价格',
    HelpCenter: '帮助中心',
    ALPABridge: 'ALPA跨链桥',
    WrongNet: '网络错误',
    Christmas: '圣诞节',
    MyScarves: '我的围巾',
    InUse: '使用中',
    Accessories: '装饰品',
    TakeOff: '脱下',
    Scarves: '围巾',
    Community: '社区论坛',
    Market: '市场',
  },
  Home: {
    Welcome: '欢迎来到羊驼之城',
    View: '查看我的羊驼',
    Adopt: '领养羊驼',
    BurnedFees: '已被燃烧的ALPA代币',
    Lauching: '羊驼之城将在12月3日22时登陆币安智能链',
    FreeClaim: `5000只0代羊驼<span style="font-weight: 500">免费空投</span>。 <a href="https://in.alpaca.city/bsc-announcement" target="_blank">点击参与</a>`,
    FreeClaimBtn: '领取免费羊驼和羊毛',
    ClaimGift: '12/21 3am UTC，免费领取圣诞节礼物！',
    FreeClaimChristmas: '领取免费NFT圣诞礼物',
    StartToFarm: '开始围巾挖矿',
	GameTitle: 'Alpacavoid 即将登场',
	GameIntro: `AlpacaVoid 是一款 2D Web3 游戏。玩家可以通过种植获得来自系统的收益，通过掠夺获得来自其他玩家的收益。游戏将在2022年3月进入大规模测试。是的，它即将登场！`,
	PlantingTitle: '种植',
	PlantingIntro: '扮演农民角色，使用 Land NFT 完成种植获得来自系统的收益，其中 Land NFT 等级对种植影响巨大。总所周知，种植时机至关重要',
	HuntingTitle: '掠夺',
	HuntingIntro: '扮演掠夺者角色，使用 Alpaca NFT 来与其他玩家发起一场羊驼大战。获胜者能够将对方的部分种植收益占为己有。虽然羊驼的能力值高的一方在战斗中具有优势，但玩家的智慧和策略才是最终决定胜负的关键',
	LandTitle: 'Land 介绍',
	LandIntro: `Land 是羊驼生活的地方。他们在那里建造，在那里种植，甚至在那里战斗以保卫他们的家园。Land 帮助羊驼从宇宙中获得 $APV，同时，羊驼在平行宇宙中迁移 Land 来获得更高的收益。<p> Land NFT 是开启游戏的钥匙，没有则无法进入游戏。Land NFT 拥有5个等级的稀缺度：<span style="font-weight: 500">Common</span>，<span style="font-weight: 500">Uncommon</span>，<span style="font-weight: 500">Rare</span>，<span style="font-weight: 500">Epic</span>以及<span style="font-weight: 500">Legenary</span>。稀缺度越高意味着 Land 的收益率越高。另外，Land 拥有多种主题：白天、夜晚以及四季。有人说，最美的雪景主题只存在于最稀有的 Land 中`,
  },
  Preview: {
    Title: '羊驼图册',
  },
  SelectAlpacas: {
    NoMyAlpaca: `你还没有羊驼 :(`,
    Adopt: '去领养',
    SortBy: '排序',
    NoAlpaca: 'No Alpaca found :(',
  },
  SelectBreeding: {
    NoAllow: '父代与子代之间不允许繁育',
    OtherAlpacas: '其它羊驼',
    SelectToBreed: '选择{parent}来繁育',
  },
  SelectFarmer: {
    SelectToFarm: '选择一只羊驼来挖矿',
  },
  Adopt: {
    TotalPrice: '总价格',
    Left: '{num}只羊驼待领养。',
    CanAdopt: '你可以领养{num}只。',
    Preview: '羊驼图册',
    NotEnoughAlpacas: '没有足够的羊驼可以被领养，请试试其它数目。',
    NotEnoughWool: '没有足够的WOOL，请试试其它数目。',
  },
  Breeding: {
    SelectAlpaca: '选择一只羊驼',
    TotalBreedingFees: '总计繁育费',
    BangBang: 'Bang Bang',
  },
  Stake: {
    TotalRewards: '总收获 (24h)',
    TotalValueStaked: '总锁仓',
    StakeIn: '质押',
    StakeOut: '解锁',
    Available: '可用的 {token}',
    Deprecated: `质押功能已经被代币燃烧机制所替代，以后被用于繁育的ALPA代币的90%都将被直接燃烧。新的燃烧机制将使ALPA代币在近几个月内实现净通缩。请解锁提出您质押的ALPA和收益。`,
    Here: '(点击查看我们做这个改动的具体原因)',
  },
  Farm: {
    AlpacaFarmer: '矿工羊驼',
    ChooseFarmer: '选择一只羊驼来增加你的收益率',
    TotalDeposit: '总共存入',
    MaxInPool: '矿池最大水平',
    MediumInPool: '矿池中间水平',
    YourAlpacaFarmer: '你的矿工羊驼',
    ALPAEarned: '已赚取的ALPA',
    LPDeposit: '已存入的ALPA/ETH token',
    LPDepositBSC: '已存入的ALPA/BNB token',
    YourWallet: '你的钱包',
    BuyALPA: '获取 ALPA',
    GetLPToken: '获取 ALPA/ETH LP tokens',
    GetLPTokenBSC: '获取 ALPA/BNB LP tokens',
    WithdrawLP: '提取 ALPA/ETH LP Token',
    WithdrawLPBSC: '提取 ALPA/BNB LP Token',
    UniswapLP: 'ALPA/ETH Uniswap LP',
    PancakeSwapLP: 'ALPA/BNB PancakeSwap LP',
    ScarfFarm: '围巾挖矿',
    ChooseScarfFarm: '选择一条围巾来挖矿',
    PoolOutdated: '矿池已过期',
    Switch:
      '我们在北京时间4月29日0点会将流动性挖矿奖励移至PancakeSwap-V2矿池. 请将你的V2流动性代币转移到新的矿池以继续获取收益。',
    SwitchPool:
      `我们会在北京时间4月22日15点将流动性挖矿奖励移至新矿池. 请将你的流动性代币转移到新的矿池以继续获取收益。
        New Alpaca LP Farm Contract on #ETH : 0x1b2318F32536AB44ECD9EA320eD83Af13779113a,
        New Alpaca LP Farm Contract on #BSC : 0xb843B7EF28587a2C36714339355D8578189c001E`,
  },
  AlpacaInfo: {
    ReadyToHatch: '等待孵化',
    ReadyToHatchIn: '准备孵化',
    AlpacaNotFound: 'Alpaca not found :(',
    BreedingFees: '繁育费: {num} ALPA',
    BreedIn: '繁育倒计时',
    BreedFeesReset:
      '繁育费将在7天后重置为基础价格。7天内每次繁育都会让繁育费按照 x2,x4,x8 的倍率增加。',
    HatchedBy: 'Hatched by',
    DateOfDeath: 'Date of death',
  },
  Presale: {
    TotalFundRaised: 'Total Fund Raised',
    PresaleCompleted: 'Presale Completed',
    LearnMore: 'Learn more about Alpaca City',
    Allocation: 'Alloction at {rate}ALPA/ETH',
  },
  TransactionResult: {
    View: '在 {addr} 上查看',
    Wait: '等待确认',
    Cancel: '交易取消',
  },
  Transfer: {
    WalletAddress: '以太坊钱包地址',
  },
  Squad: {
    ALPAEarned: '赚取的ALPA',
    WeeklyReward: '预计每周收益',
    MySquad: '我的羊驼部落',
    SquadMemebers: '{num}个部落成员',
    TotalEnergy: '{num} 总能量值',
    AvgEnergy: '{num} 平均能量值',
    PercentageReward: '占矿池收益的 {num}%',
    NoSquad: '请选择羊驼来组建你的部落！',
    AlpacaSquad: '羊驼部落',
    SquadFarm: '部落挖矿',
    RewardEarned: '待收取',
    BSCCelebrate:
      '为了庆祝羊驼之城上线币安智能琏，我们的合作伙伴 DEGO，Bounce Finance，BurgerSwap为羊驼之城捐赠了总计7000美金等值的DEGO，BOT和BURGER代币，这些代币将全部奖励给第一周参与部落挖矿的用户。<a href="https://in.alpaca.city/squad-bonus" target="_blank">了解更多</a>。',
  },
  SelectSquad: {
    SelectAssign: '选择羊驼来组建部落',
    SelectRecall: '选择羊驼来召回',
    MaxWarning: `所选的羊驼部落成员数已经达到上限。`,
  },
  Trade: {
    TotalAlpacasRecycled: '总共已回收',
    MyRecycledAlpacas: '我已回收',
    MyBalance: '我的WOOL',
    RecycleAlpaca: '回收羊驼',
    ExchangeAlpaca: '置换羊驼',
  },
  Recycle: {
    Choose: '回收羊驼来获得',
  },
  SelectRecycle: {
    SelectRecycle: '选羊驼去回收',
    SelectedInfo:
      '已选 <span class="text-blue">{num}</span> 只羊驼共 <span class="text-blue">{energy}</span> 能量值，回收后可以得到 <span class="text-blue">{wool} WOOL</span>',
  },
  AdoptCenter: {
    Left: '{num}只羊驼可被置换',
    feesInfo: '这项费用是在区块链上产生新羊驼的成本',
    canAdoptNum: '你可以交换{num}只羊驼。 ',
  },
  Referral: {
    Rule:
      '邀请好友赚ALPA！获得好友繁育费5%的返佣。繁育费的90%会被销毁，所以5%的推荐返佣来自于10%的团队原有分配额。为了成功获得返佣，请确保你邀请的好友正确地填入你的钱包地址并保存。佣金将在北京时间每周一早上11点发放。',
    MyReferrer: '我的推荐人',
    MyReferralLink: '我的邀请链接',
    MyCommission: '我的返佣',
    CommissionRate: '返佣比例: 繁育费的<span class="text-blue">5%</span>',
    Friends: '好友数量',
    TotalCommissions: '总计得到佣金',
    CommissionRecords: '返佣记录',
    NoRecords: '没有任何记录',
    LearnMore: '了解更多',
    From: '来自好友',
    YourReferrerAddress: '填写推荐人地址',
    LinkCopied: '邀请链接复制成功！',
    CopyFailed: '邀请链接复制失败',
    AcceptSuccess: '接受邀请成功',
    InvalidAddress: '无效的地址',
    CycleReferral: '不允许循环推荐',
    Title: '邀请好友赚ALPA',
    InvitedBy: '邀请人',
    AcceptInvitation: '接受邀请',
  },
  WoolStake: {
    ManageStake: '管理质押',
    WinWool: '质押ALPA赚取WOOL',
    Detail: '质押10000 ALPA每天大约能赚取 1000 WOOL。',
    Detail2: '最多可质押50,000 ALPA。',
  },
  Traits: {
    accent_color: '强调色',
    base_color: '基本色',
    ears: '耳朵',
    eye_color: '眼睛颜色',
    eye_shape: '眼睛形状',
    hairs: '头发',
    highlight_color: '高亮色',
    mouth: '嘴巴',
    pattern: '花纹',
    tail: '尾巴',
    unknown1: '未知一',
    unknown2: '未知二',
  },
  Boost: {
    GensisAlpaca: '创世羊驼',
    EnergyDrinks: '能量饮料',
    Green: 'Green Bull',
    Blue: 'Blue Bull',
    Red: 'Red Bull',
  },
  Airdrop: {
    ForWhitelistedPlayers: '白名单',
    ForOGs: '老用户',
    WhiteClaimAlpaca: '白名单地址能免费领取1个羊驼，先到先得。',
    ClaimAlpacaBtn: '免费领取羊驼',
    WhiteClaimWool:
      '免费领取500羊毛。羊毛可以被用作换取高能量值的0代羊驼和限量版羊驼。',
    ClaimWoolBtn: '领取500羊毛',
    OGClaimAlpaca:
      '截止北京时间2020年11月30日0点，所有在以太坊上ALPA token或羊驼 NFT 的拥有者都可以免费领取两只0代羊。',
    NoAlpaca: '羊驼空投已领完',
  },
  SelectScarf: {
    SelectScarf: '选择一条围巾来佩戴',
    Activity1:
      '圣诞矿池的开放时间是北京时间 2020/12/21 11:00 ～ 2021/1/2 7:59。',
    Activity2:
      '你至多可以质押一条圣诞围巾来来挖矿赚取等值{num}美金的ALPA奖励。',
  },
};
